export default __webpack_public_path__ + "static/media/mic-active-white.cc0e9ddc.svg";